import { render, staticRenderFns } from "./back-btn.vue?vue&type=template&id=36ebc7b4"
import script from "./back-btn.vue?vue&type=script&lang=js"
export * from "./back-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports